import React  from 'react';
import SideNav from "./widgets/SideNav";
import Navbar from "./widgets/Navbar";
import Footer from "./widgets/Footer";

export default ({ children }) => {

    return (
        <div>
            <SideNav />


            <div class="page-wrapper">

                <Navbar />

                <div class="page-content">
                    {children}
                </div>

                <Footer/>
            </div>
        </div>
    );
}
